<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="11">
          <el-card class="box-card" header="选择题目">
            <el-tree
              ref="tree"
              :data="tree"
              show-checkbox
              node-key="id"
              :default-expanded-keys="defaultExpandedKeys"
              highlight-current
              default-expand-all
              @check-change="handleTreeChange"
              class="max-h-80 overflow-y-auto border border-black"
            />
          </el-card>
        </el-col>
        <el-col :span="11" :offset="2">
          <el-card class="box-card" header="选择专家">
            <el-select v-model="selectedUsers" multiple :multiple-limit="1" placecholder="请选择专家">
              <el-option v-for="user in users" :key="user.id" :label="user.name" :value="user.id" />
            </el-select>
          </el-card>
        </el-col>
      </el-row>

      <el-button type="primary" @click="handleAssign" :disabled="disabled" v-loading="loading">确定</el-button>
    </el-main>
  </el-container>
</template>

<script>
export default {
  props: ['evaluate', 'evaluateScenes', 'users'],
  data () {
    return {
      loading: false,
      defaultExpandedKeys: [],
      selectedNodes: [],
      selectedUsers: []
    }
  },
  computed: {
    questions () {
      return this.evaluate.reduce((obj, item) => {
        obj.cache[item.id] = item
        item.parent = obj.cache[item.parentId]
        if (item.level === 3) {
          obj.arr.push(item)
        } else if (item.level === 4) {
          obj.cache[item.parentId].question = Object.assign(item, { children: [] })
          obj.cache[item.parentId].i = item.i
          delete item.parent
        } else if (item.level === 5) {
          obj.cache[item.parentId].children.push(item)
          delete item.parent
        }
        return obj
      }, { arr: [], cache: {} }).arr
    },
    scenes () {
      return this.evaluateScenes.reduce((obj, item) => {
        obj.cache[item.id] = item
        item.parent = obj.cache[item.parentId]
        if (item.level === 2) {
          obj.arr.push(Object.assign(item, { i: obj.arr.length + 1 }))
          item.children = []
        } else if (item.level === 3) {
          obj.cache[item.parentId].children.push(item)
          delete item.parent
        }
        return obj
      }, { arr: [], cache: {} }).arr
    },
    tree () {
      return [
        {
          id: 'question',
          label: '答卷',
          children: this.questions.map(v => ({ id: `q-${v.question.id}`, label: v.name, type: 'question' }))
        },
        {
          id: 'scene',
          label: '场景',
          children: this.scenes.map(v => ({ id: `s-${v.id}`, label: v.name, type: 'scene' }))
        }
      ]
    },
    disabled () {
      return this.selectedUsers.length === 0 || this.selectedNodes.length === 0
    }
  },
  mounted () {
    this.$refs.tree.setCheckedKeys(['question', 'scene'])
  },
  methods: {
    handleTreeChange (checkedNodes, checkedKeys) {
      this.selectedNodes = checkedKeys
      const keys = this.$refs.tree.getCheckedKeys()
      this.selectedNodes = keys.filter(v => v.startsWith('q-') || v.startsWith('s-'))
    },
    handleAssign () {
      this.$emit('save', [this.selectedNodes, this.selectedUsers])
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 10000)
    }
  }
}
</script>
